import { take, takeLatest } from "redux-saga/effects";

import { Creators as AllCreators, Types as AllTypes } from "../../actions";
import { deleteClass, fetchAllClasses } from "../../actions/classes";
import { Action, handleFetchAllClassesFailure, handleFetchAllClassesSuccess } from "../../App/Classes/actions";
import * as actions from "../../App/Classes/actions";
import { addNewClass } from "../../App/Classes/sagas";

const Creators = (AllCreators as any).App.Classes;
const Types = (AllTypes as any)._APP._CLASSES;

export function* watchFetchAllClasses() {
  yield takeLatest(
    Action.FETCH_ALL_CLASSES,
    fetchAllClasses({
      onFailure: handleFetchAllClassesFailure,
      onSuccess: handleFetchAllClassesSuccess,
    })
  );
}

export function* watchDeleteClass() {
  yield takeLatest(
    Types.DELETE_CLASS,
    deleteClass({
      onFailure: Creators.handleDeleteClassFailure,
      onSuccess: Creators.handleDeleteClassSuccess,
    })
  );
}

export function* watchAddNewClass() {
  yield takeLatest(
    Action.ADD_NEW_CLASS,
    addNewClass({
      onFailure: actions.handleAddNewClassFailure,
      onSuccess: actions.handleAddNewClassSuccess,
    })
  );
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
